import { useMutation } from '@tanstack/react-query';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { ERROR_DEFAULT } from 'src/messages/assets';
import Project from 'src/entities/project';
import useProjectSystem from '../systems/useProjectSystem';

type RequestSeatParams = {
  emails: string[];
  project: Project;
};

const useRequestSeatsMutation = () => {
	const system = useProjectSystem();
	const snackbarSystem = useSnackbarSystem();

	return useMutation( {
		mutationFn: ( params: RequestSeatParams ) => system.requestSeatsFor( params ),
		onSuccess: ( _, variables ) => {
			snackbarSystem.showSuccessMessage( {
				title: 'Upgrade request sent to Workspace Owner.',
				description: `A request was sent for the following email${variables.emails.length === 1 ? '' : 's'}: ${variables.emails.join( ', ' )}.`
			} );
		},
		onError: ( ) => {
			snackbarSystem.showErrorMessage( { title: ERROR_DEFAULT } );
		}
	} );
};

export default useRequestSeatsMutation;
